import {
  Component, Input, Output, EventEmitter, AfterViewInit,
  ViewChildren, QueryList, ElementRef, HostListener
} from '@angular/core';

type AutoFocusOpt = 'none' | 'first' | 'cancel' | number | string;

@Component({
  selector: 'app-confirmation-choix-custom',
  templateUrl: './confirmation-choix-custom.component.html',
  styleUrls: ['./confirmation-choix-custom.component.scss']
})
export class ConfirmationChoixCustomComponent implements AfterViewInit {
  @Input() header!: string;
  @Input() msg!: string;
  @Input() list: string[] = [];        // ex: ['Créer','Associer','Annuler']
  @Input() msgIsHtml = false;
  @Input() dismissible = true;         // backdrop / Échap / croix
  @Input() autoFocus: AutoFocusOpt = 'cancel';

  @Output() select = new EventEmitter<string>();
  @Output() closed = new EventEmitter<void>();

  @ViewChildren('actionBtn') actionBtns!: QueryList<ElementRef<HTMLButtonElement>>;

  public defaultIdx: number = -1;

  private normalize = (s: string) =>
    (s || '')
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '') // enlève accents
      .toLowerCase()
      .trim();

  // Libellés considérés comme “annulation”
  private cancelWords = new Set(['annuler','non','quitter','fermer','cancel','no','close']);

  private resolveIndexFromAutoFocus(): number | null {
    if (this.autoFocus === 'none') return null;
    if (this.autoFocus === 'first') return this.list.length ? 0 : null;

    if (this.autoFocus === 'cancel') {
      const i = this.list.findIndex(l => this.cancelWords.has(this.normalize(l)));
      return i >= 0 ? i : null;
    }

    if (typeof this.autoFocus === 'number') {
      return this.autoFocus >= 0 && this.autoFocus < this.list.length ? this.autoFocus : null;
    }

    // string label → try exact (case/accents-insensitive) match
    if (typeof this.autoFocus === 'string') {
      const target = this.normalize(this.autoFocus);
      const i = this.list.findIndex(l => this.normalize(l) === target);
      return i >= 0 ? i : null;
    }

    return null;
  }

  ngAfterViewInit(): void {
    setTimeout(() => {
      const idx = this.resolveIndexFromAutoFocus();
      if (idx == null) return; // no focus
      this.defaultIdx = idx;
      const btn = this.actionBtns?.toArray()[idx]?.nativeElement;
      btn?.focus();
    }, 0);
  }

  isDefault(i: number): boolean { return i === this.defaultIdx; }

  onBackdropClick() { if (this.dismissible) this.closed.emit(); }
  onCloseClick()    { if (this.dismissible) this.closed.emit(); }
  onChoose(choice: string) { this.select.emit(choice); }

  @HostListener('document:keydown.escape', ['$event'])
  onEsc(e: KeyboardEvent) {
    if (!this.dismissible) return;
    e.preventDefault();
    this.closed.emit();
  }
}
